import { render, staticRenderFns } from "./OrdersByMonthChart.vue?vue&type=template&id=708450e4&"
import script from "./OrdersByMonthChart.vue?vue&type=script&lang=js&"
export * from "./OrdersByMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports